import React from 'react';

const SideBarGroupLabel = ({ children, className = '' }) => (
  <div className={`px-3 pt-4 pb-1.5 first:pt-2 ${className}`}>
    <h3 className="text-[12px] font-semibold text-gray-500 dark:text-gray-400">
      {children}
    </h3>
  </div>
);

const SideBarGroup = ({ label, children, className = '' }) => (
  <div className={`mb-2 ${className}`}>
    {label && <SideBarGroupLabel>{label}</SideBarGroupLabel>}
    <ul className="px-1 space-y-0.5">{children}</ul>
  </div>
);

export { SideBarGroup, SideBarGroupLabel };
export default SideBarGroup;
